import Search from './search';
import Flyout from './flyout';
import Hamburger from './hamburger';
import Accordion from './accordion';
import { throttle } from 'lodash';

class Header {
	flyouts = [];
	hamburger = null;
	isMobileMenuOpen = false;

	constructor($el) {
		this.$el = $el;

		this.$search = $el.find('[data-search="el"]');
		this.$flyoutBackdrop = $el.find('[data-header="flyout-backdrop"]');
		this.setHeight();
		this.init();
	}

	init = () => {
		this.initHamburger();
		this.initMobileSubmenu();
		this.initSearch();
		this.initFlyout();
		this.initObserver();
		$(window).on('resize', throttle(this.resizeHandler, 250));
	};

	initSearch = () => {
		this.$search.each((i, el) => {
			new Search($(el));
		});
	};

	setHeight = () => {
		this.height = this.$el.outerHeight();
	};

	initFlyout = () => {
		this.$flyout = this.$el.find('[data-flyout="el"]');

		this.$flyout.each((i, el) => {
			this.flyouts.push(new Flyout($(el, this.$flyoutBackdrop)));
		});
	};

	initObserver = () => {
		this.observer = window._Observer.create({
			target: window,
			onChangeY: this.onChangeY,
		});
	};

	onChangeY = e => {
		const top = this.height - e.scrollY();
		this.setFlyoutTop(top);
	};

	setFlyoutTop = top => {
		this.flyouts.forEach(flyout => {
			flyout.setTop(top);
		});
	};

	resetFlyoutPosition = () => {
		this.setFlyoutTop(this.height);
	};

	//  init mobile submenu
	initMobileSubmenu = () => {
		this.$mobileSubmenu = this.$el.find('[data-submenu="el"]');

		this.$mobileSubmenu.each((i, el) => {
			new Accordion($(el));
		});
	};

	initHamburger = () => {
		this.hamburger = new Hamburger(this.$el.find('[data-hamburger="el"]'));
	};

	setFlyoutHeight = () => {
		this.flyouts.forEach(flyout => {
			flyout.calculateHeight();
		});
	};

	resizeHandler = () => {
		this.setHeight();
		this.setFlyoutHeight();
	};
}

export default Header;
